class StateCode {
  static EN_CREACION = 'I01';
  static PENDIENTE = 'I02';
  static ACEPTADA = 'I03';
  static CONFIRMADA = 'I05';
  static A_CONTABILIZAR = 'I06';
  static AUTORIZADA = 'I07';
  static PENDIENTE_ENVIO_SAGE = 'I08';
  static EN_PROCESO_DE_PAGO = 'I09';
  static PAGADA = 'I10';

  constructor(private code: string) {}

  public isEnCreacion(): boolean {
    return this.code === StateCode.EN_CREACION;
  }

  public isPendiente(): boolean {
    return this.code === StateCode.PENDIENTE;
  }

  public isAceptada(): boolean {
    return this.code === StateCode.ACEPTADA;
  }

  public isConfirmada(): boolean {
    return this.code === StateCode.CONFIRMADA;
  }

  public isAContabilizar(): boolean {
    return this.code === StateCode.A_CONTABILIZAR;
  }

  public isAutorizada(): boolean {
    return this.code === StateCode.AUTORIZADA;
  }

  public isPendienteEnvioSAGE(): boolean {
    return this.code === StateCode.PENDIENTE_ENVIO_SAGE;
  }

  public isEnProcesoDePago(): boolean {
    return this.code === StateCode.EN_PROCESO_DE_PAGO;
  }

  public isPagada(): boolean {
    return this.code === StateCode.PAGADA;
  }

  public canRejectInvoice(): boolean {
    return (
      this.isPendiente() || this.isAceptada() || this.isConfirmada() || this.isAContabilizar() || this.isAutorizada()
    );
  }

  public canModify(): boolean {
    return this.isConfirmada() || this.isAContabilizar() || this.isAutorizada();
  }

  public isInNotSentStates(): boolean {
    return this.isPendienteEnvioSAGE() || this.isPagada();
  }

  public getRejectTargetStates(): string[] {
    if (this.isPendiente()) {
      return [StateCode.EN_CREACION];
    }
    if (this.isAceptada()) {
      return [StateCode.EN_CREACION, StateCode.PENDIENTE];
    }
    if (this.isConfirmada()) {
      return [StateCode.EN_CREACION, StateCode.PENDIENTE, StateCode.ACEPTADA];
    }
    if (this.isAContabilizar()) {
      return [StateCode.EN_CREACION, StateCode.PENDIENTE, StateCode.ACEPTADA, StateCode.CONFIRMADA];
    }
    if (this.isAutorizada()) {
      return [
        StateCode.EN_CREACION,
        StateCode.PENDIENTE,
        StateCode.ACEPTADA,
        StateCode.CONFIRMADA,
        StateCode.A_CONTABILIZAR,
      ];
    }
    return [];
  }

  public static pagada(): StateCode {
    return new StateCode(StateCode.PAGADA);
  }

  public value(): string {
    return this.code;
  }
}

export default StateCode;
